<div class="border-t-2 flex flex-col gap-4">
    <div class="h-40 bg-tw-lightgrey border-b-2 border-dashed flex justify-around items-center">
        <div class="flex flex-row justify-start items-center w-[30%] bg-white p-2">
            <div class="flex h-fit italic font-bold">{{ selection['A'] ? (selection['A'].flow | translate) : ( 'DOCUMENT_A' | translate) }}</div>
            <div *ngIf="selection['A'] && selection['A'].flow && selection['A'].relecture" class="bg-tw-text-light text-tw-blue border-tw-blue ml-3 border-[1px] flex flex-row align-middle justify-center w-[2em] h-[2em]">
                <div class="flex leading-[2em]"> {{ getPrefixRelecture(selection['A'].flow).short }}{{ selection['A'].relecture }} </div>
            </div>
        </div>
        <mat-icon svgIcon="compare_arrows"></mat-icon>
        <div class="flex flex-row justify-start items-center w-[30%] bg-white p-2">
            <div class="flex h-fit italic font-bold">{{ selection['B'] ? (selection['B'].flow | translate) : ( 'DOCUMENT_B' | translate) }}</div>
            <div *ngIf="selection['B'] && selection['B'].flow && selection['B'].relecture" class="bg-tw-text-light text-tw-blue border-tw-blue ml-3 border-[1px] flex flex-row align-middle justify-center w-[2em] h-[2em]">
                <div class="flex leading-[2em]"> {{ getPrefixRelecture(selection['B'].flow).short }}{{ selection['B'].relecture }} </div>
            </div>
        </div>
    </div>
    <div class="p-8">
        <h4 class="py-4">{{ 'SELECT_DOCUMENT_TO_COMPARE' | translate }}</h4>
        <div class="flex justify-between w-full">
            <div class="w-[40%]">
                <p class="italic border-b-2 py-2">{{ 'DOCUMENT_A' | translate }}</p>
                <app-flows-version-selector [mode]="'extern'" [compare]="true" (versionSelected)="selected('A', $event)"></app-flows-version-selector>
            </div>
            <mat-divider vertical></mat-divider>
            <div class="w-[40%]">
                <p class="italic border-b-2 py-2">{{ 'DOCUMENT_B' | translate }}</p>
                <app-flows-version-selector [mode]="'extern'" [compare]="true" (versionSelected)="selected('B', $event)"></app-flows-version-selector>
            </div>
        </div>
    </div>
    <div class="border-t-2 border-dashed p-4">
        <span class="italic text-sm">{{ 'DETAILS' | translate }}</span>
        <div *ngIf="RA || RB" class="flex flex-col justify-between w-full">
            <div *ngIf="RA" class="w-full">
                <p class="italic border-t-2 pt-2">{{ 'DOCUMENT_A' | translate }}</p>
                <app-members-assessments [members]="RA.members" [readonly]="true"></app-members-assessments>
            </div>
            <mat-divider></mat-divider>
            <div *ngIf="RB" class="w-full">
                <p class="italic border-t-2 pt-2">{{ 'DOCUMENT_B' | translate }}</p>
                <app-members-assessments [members]="RB.members" [readonly]="true"></app-members-assessments>
            </div>
        </div>
    </div>
</div>
<!-- <div class="versions" *ngIf="approvalHistoryItems.length">
    <button class="reset-btn" mat-stroked-button (click)="reset()"> {{'COMPARE_RESET'| translate}} </button>
    <div class="mt-4 select-versions-container">
        <p>{{ 'CLIENT_REVISIONS' | translate}}</p>
        <div class="select-versions">
            <div class="version v-1 pr-2">
                <mat-form-field appearance="fill">
                    <mat-label>{{'COMPARE_DOC_A' | translate}} </mat-label>
                    <mat-select [(value)]="RA" [disabled]="RA">
                        <ng-container *ngFor="let item of approvalHistoryItems">
                            <mat-option disabled="true" class="select-flow-separator">
                                <strong>{{ item.flow | translate }}</strong>
                            </mat-option>
                            <mat-option *ngFor="let key of getKeys(item.history)" [value]="item.history[key]"> {{ item.history[key].labels.relecture }} </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="version v-2">
                <mat-form-field appearance="fill">
                    <mat-label>{{'COMPARE_DOC_B' | translate}} </mat-label>
                    <mat-select [(value)]="RB" [disabled]="RB">
                        <ng-container *ngFor="let item of approvalHistoryItems">
                            <mat-option disabled="true" class="select-flow-separator">
                                <strong>{{ item.flow | translate }}</strong>
                            </mat-option>
                            <mat-option *ngFor="let key of getKeys(item.history)" [value]="item.history[key]"> {{ item.history[key].labels.relecture }} </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
</div>
<div class="container-versions">
    <div *ngIf="RA" class="va pb-2">
        <span class="sub-title">{{'COMPARE_DOC_A' | translate}} - {{ RA.labels.relecture }} - <span [ngClass]="RA.assessment">{{ RA.assessment | translate }}</span></span>
        <app-members-assessments [members]="RA.members" [readonly]="true"></app-members-assessments>
    </div>
    <div *ngIf="RB" class="vb">
        <span class="sub-title">{{'COMPARE_DOC_B' | translate}} - {{ RB.labels.relecture }} - <span [ngClass]="RB.assessment">{{ RB.assessment | translate }}</span></span>
        <app-members-assessments [members]="RB.members" [readonly]="true"></app-members-assessments>
    </div>
</div> -->